import { FormattedMessage } from "react-intl";
import { Table, TableCell, TableHeader, TableRow } from "~/components/ui/table";

export const ArchivedCasesListHeader = () => {
  return (
    <Table>
      <TableHeader>
        <TableRow className="text-zinc-500 !text-sm !font-medium leading-tight w-full grid grid-cols-6 sm:grid-cols-12 gap-2 sm:gap-4">
          <TableCell className="py-4 font-medium col-span-3 sm:col-span-4">
            <FormattedMessage id="name" />
          </TableCell>
          <TableCell className="py-4 col-span-2 hidden sm:flex">
            <FormattedMessage id="documents" defaultMessage="Documents" />
          </TableCell>
          <TableCell className="py-4 col-span-2">
            <FormattedMessage id="documentsList.archivedAt" />
          </TableCell>
          <TableCell className="py-4 col-span-2 hidden sm:flex">
            <FormattedMessage id="documentsList.archivedBy" />
          </TableCell>
          <TableCell className="py-4 text-right col-span-1 sm:col-span-2" />
        </TableRow>
      </TableHeader>
    </Table>
  );
};
